import { gql } from 'graphql-request'

export const GET_MY_BOOK_COLLECTION = gql`
  query GetMyBookCollection(
    $searchText: String
    $category: Int
    $bookType: BookType
  ) {
    getMyBookCollection(
      searchText: $searchText
      category: $category
      bookType: $bookType
    ) {
      book {
        id
        title
        writer
        coverImgPath
        penName {
          firstPenName
        }
      }
    }
  }
`
